<template>
  <Adminlte>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary center-block">
          <div class="box-header with-border">
            <h3 class="box-title">Validar Questionário - "{{ parkName }}" - {{ referenceYear }}</h3>
            <form role="form" v-if="this.questionsByAxis">
              <div class="box-body">
                <tabs class="nav-tabs-custom" :value="this.activeAxis" v-on:active="setActiveAxis">
                  <tab v-for="(axis, index) in Object.keys(this.questionsByAxis)" :header="axisHeader(axis)" :key="index">
                    <component
                      v-for="q in questionsByAxis[axis]"
                      v-if="quiz && q.isVisible"
                      v-bind:key="q.uuid"
                      ref="questions"
                      :is="getQuestionComponent(q)"
                      :question="q"
                      :isDisabled="true"
                      :answer="getQuestionAnswer(q)">
                    </component>
                  </tab>
                </tabs>
              </div>

              <div class="box-footer">
                <div class="footer-btns">
                  <button type="button" class="btn btn-sm btn-info" @click="goBack()">
                    <i class="fa fa-arrow-left"></i>&nbsp; Voltar
                  </button>
                  <span>
                    <button type="button" class="btn btn-sm btn-warning" @click="disapproveCurrentAxis()">
                      <i class="fa fa-times"></i>&nbsp; Reprovar Eixo
                    </button>
                    <button type="button" class="btn btn-sm btn-primary" @click="approveCurrentAxis()">
                      <i class="fa fa-check"></i>&nbsp; Aprovar Eixo
                    </button>
                  </span>
                  <span>
                    <button type="button"
                      class="btn btn-sm btn-danger"
                      :disabled="!isAbleToDisapproveQuiz"
                      data-toggle="modal"
                      data-target="#disapproval-modal"
                    >
                      <i class="fa fa-times-circle"></i>&nbsp; Reprovar Questionário
                    </button>
                    <button type="button"
                      class="btn btn-sm btn-success"
                      :disabled="!isAbleToApproveQuiz"
                      data-toggle="modal"
                      data-target="#approval-modal"
                    >
                      <i class="fa fa-check-circle"></i>&nbsp; Aprovar Questionário
                    </button>
                  </span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Disapproval Modal -->
    <div class="modal fade" id="disapproval-modal" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Reprovar Questionário</h4>
          </div>
          <div class="modal-body">
            <p>Ao clicar em "Ok" o questionário será reprovado e devolvido ao parque tecnológico. Deseja continuar?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="disapproveQuiz()">Ok</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Approval Modal -->
    <div class="modal fade" id="approval-modal" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Aprovar Questionário</h4>
          </div>
          <div class="modal-body">
            <p>Ao clicar em "Ok" o questionário será aprovado e finalizado. Deseja continuar?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="approveQuiz()">Ok</button>
          </div>
        </div>
      </div>
    </div>
    <notifier ref="notifier"></notifier>
  </Adminlte>
</template>

<script>
import Adminlte from '@/components/template/Adminlte'
import { tabs, tab } from 'vue-strap'
import Notifier from '@/components/elements/Notifier'
import DateQuestion from './questions/DateQuestion'
import MultipleChoiceQuestion from './questions/MultipleChoiceQuestion'
import CollectionQuestion from './questions/CollectionQuestion'
import BooleanFormQuestion from './questions/BooleanFormQuestion'
import BooleanCollectionQuestion from './questions/BooleanCollectionQuestion'
import FormQuestion from './questions/FormQuestion'
import ItemsQuestion from './questions/ItemsQuestion'
import ParkQuizClient, {PARK_QUIZ_TEMPLATE_UUID} from '@/services/resource_client/park_quiz'
import QuizTemplateClient from '@/services/resource_client/quiz_template'
import QuizEvaluationClient from '@/services/resource_client/quiz_evaluation'

export default {
  name: 'ParkQuizValidation',
  components: { Adminlte, tabs, tab, Notifier },
  props: ['parkId', 'parkName', 'referenceYear', 'quizUuid'],
  data () {
    return {
      questionsByAxis: {},
      quiz: null,
      quizEvaluation: {},
      activeAxis: 0,
      componentsPerType: {
        'date': DateQuestion,
        'multiple-choice': MultipleChoiceQuestion,
        'collection': CollectionQuestion,
        'boolean-form': BooleanFormQuestion,
        'boolean-collection': BooleanCollectionQuestion,
        'form': FormQuestion,
        'items': ItemsQuestion
      }
    }
  },
  mounted () {
    this.getQuizTemplate()
    this.getQuiz()
    this.setQuizEvaluation()
  },
  computed: {
    isAbleToDisapproveQuiz () {
      return this.hasAllAxisBeenValidated && this.quizEvaluation.disapprovedAxis.length > 0
    },
    isAbleToApproveQuiz () {
      return this.hasAllAxisBeenValidated && this.quizEvaluation.disapprovedAxis.length === 0
    },
    hasAllAxisBeenValidated () {
      if (!this.quizEvaluation || Object.keys(this.quizEvaluation).length < 1) {
        return false
      }
      let numberOfAxis = Object.keys(this.questionsByAxis).length
      return this.quizEvaluation.approvedAxis.length + this.quizEvaluation.disapprovedAxis.length === numberOfAxis
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    getQuizTemplate () {
      QuizTemplateClient.get(PARK_QUIZ_TEMPLATE_UUID, this.parkId).then(r => {
        this.questionsByAxis = this.getQuestionsByAxis(r.data.questions)
      })
    },
    getQuiz () {
      ParkQuizClient
        .getByYear(this.parkId, this.referenceYear)
        .then(r => {
          this.quiz = r.data[0]
        })
    },
    setQuizEvaluation () {
      this.getQuizEvaluation().then((r) => {
        if (r.total === 1) {
          this.quizEvaluation = r[0]
          this.quizEvaluation.isParkQuizApproved = null
          return
        }
        this.createQuizEvaluation().then((r) => {
          this.quizEvaluation = r
        })
      })
    },
    getQuizEvaluation () {
      return QuizEvaluationClient.byParkQuizUuid(this.quizUuid)
        .then((r) => {
          return r.data
        })
    },
    createQuizEvaluation () {
      return QuizEvaluationClient.post(this.quizUuid)
        .then((r) => {
          return r.data
        })
    },
    putQuizEvaluation () {
      return QuizEvaluationClient.put(
        this.quizEvaluation.id,
        this.parkQuizUuid,
        this.quizEvaluation.approvedAxis,
        this.quizEvaluation.disapprovedAxis,
        this.quizEvaluation.isParkQuizApproved
      )
    },
    getQuestionsByAxis (questions) {
      let questionsByAxis = this.sortQuestionsByAxis(questions)
      Object.keys(questionsByAxis).forEach(k => {
        questionsByAxis[k] = this.sortQuestionsByRenderingOrder(questionsByAxis[k])
      })
      return questionsByAxis
    },
    sortQuestionsByAxis (questions) {
      let questionsByAxis = {
        'Gestão': [],
        'Serviços': [],
        'Infraestrutura': [],
        'Equipe': [],
        'Parceiros': []
      }
      questions.forEach(e => {
        let axis = e.axis
        if (!questionsByAxis.hasOwnProperty(e.axis)) {
          questionsByAxis[axis] = []
        }
        questionsByAxis[axis].push(e)
      })
      return questionsByAxis
    },
    sortQuestionsByRenderingOrder (questions) {
      questions.sort(function (a, b) {
        return a.renderingOrder - b.renderingOrder
      })
      return questions
    },
    getQuestionComponent (q) {
      return this.componentsPerType[q.type]
    },
    getQuestionAnswer (q) {
      if (!q.isVisible || this.quiz === null) {
        return
      }
      for (let answerIndex in this.quiz.answers) {
        let answer = this.quiz.answers[answerIndex]
        if (answer.questionUuid === q.uuid) {
          return answer
        }
      }
      return this.addDefaultAnswerForQuestion(q)
    },
    addDefaultAnswerForQuestion (question) {
      const defaultAnswer = {
        'questionUuid': question.uuid,
        'value': null
      }

      const answersLength = Object.keys(this.quiz.answers).length
      this.quiz.answers[answersLength] = defaultAnswer

      return defaultAnswer
    },
    setActiveAxis (index) {
      this.activeAxis = index
    },
    approveCurrentAxis () {
      const currentAxisName = this.getCurrentAxisName()
      if (this.quizEvaluation.approvedAxis.includes(currentAxisName)) {
        this.goToNextAxisAndScrollToTop()
        return
      }
      this.quizEvaluation.disapprovedAxis = this.quizEvaluation.disapprovedAxis.filter((el) => el !== currentAxisName)
      this.quizEvaluation.approvedAxis.push(currentAxisName)
      this.putQuizEvaluation().then(() => {
        this.goToNextAxisAndScrollToTop()
      })
    },
    disapproveCurrentAxis () {
      const currentAxisName = this.getCurrentAxisName()
      if (this.quizEvaluation.disapprovedAxis.includes(currentAxisName)) {
        this.goToNextAxisAndScrollToTop()
        return
      }
      this.quizEvaluation.approvedAxis = this.quizEvaluation.approvedAxis.filter((el) => el !== currentAxisName)
      this.quizEvaluation.disapprovedAxis.push(currentAxisName)
      this.putQuizEvaluation().then(() => {
        this.goToNextAxisAndScrollToTop()
      })
    },
    getCurrentAxisName () {
      return Object.keys(this.questionsByAxis)[this.activeAxis]
    },
    goToNextAxisAndScrollToTop () {
      this.goToNextAxis()
      this.scrollToTop()
    },
    goToNextAxis () {
      if (this.isLastAxis(this.activeAxis)) {
        this.goToFirstAxis()
        return
      }
      this.activeAxis += 1
    },
    isLastAxis (axis) {
      return axis === Object.keys(this.questionsByAxis).length - 1
    },
    goToFirstAxis () {
      this.activeAxis = 0
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    axisHeader (axisName) {
      if (!this.quizEvaluation || Object.keys(this.quizEvaluation).length < 1) {
        return `<i class="fa fa-square-o"></i> ${axisName}`
      }
      if (this.quizEvaluation.approvedAxis.includes(axisName)) {
        return `<i class="fa fa-check-square-o text-green"></i> ${axisName}`
      }
      if (this.quizEvaluation.disapprovedAxis.includes(axisName)) {
        return `<i class="fa fa-window-close-o text-danger"></i> ${axisName}`
      }
      return `<i class="fa fa-square-o"></i> ${axisName}`
    },
    disapproveQuiz () {
      if (this.isAbleToDisapproveQuiz) {
        this.quizEvaluation.isParkQuizApproved = false
        this.putQuizEvaluation().then(() => {
          this.$notify({ type: 'success', title: 'Questionário Reprovado', text: 'O questionário foi reprovado.' })
          this.goBack()
        })
        return
      }
      throw Error('Unable to disapprove quiz')
    },
    approveQuiz () {
      if (this.isAbleToApproveQuiz) {
        this.quizEvaluation.isParkQuizApproved = true
        this.putQuizEvaluation().then(() => {
          this.$notify({ type: 'success', title: 'Questionário Aprovado', text: 'O questionário foi aprovado.' })
          this.goBack()
        })
        return
      }
      throw Error('Unable to approve quiz')
    }
  }
}
</script>

<style scoped>
  .footer-btns {
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// ParkQuizValidation.vue?508e6b34